export default () => ({
  component: 'withdrawal-method-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
